import React from 'react';

const ReportExpensesListOne = ({expenses}) => {
    return (
        <div className="container mx-auto mt-2">
            <table className="min-w-full bg-white border border-gray-300">
                <thead>
                <tr>
                    <th className="py-2 px-4 border-b">Category</th>
                    <th className="py-2 px-4 border-b">Payment Mode</th>
                    <th className="py-2 px-4 border-b">Date</th>
                    <th className="py-2 px-4 border-b">Note</th>
                    <th className="py-2 px-4 border-b">Amount</th>
                </tr>
                </thead>
                <tbody>
                {expenses.map(expense => (
                    <tr key={expense.id}>
                        <td className="py-2 px-4 border-b text-center">{expense.expense_category.name}</td>
                        <td className="py-2 px-4 border-b text-center">{expense.mode_of_payment.name}</td>
                        <td className="py-2 px-4 border-b text-center">{expense.date}</td>
                        <td className="py-2 px-4 border-b text-center">{expense.note}</td>
                        <td className="py-2 px-4 border-b text-center">{expense.amount}</td>
                    </tr>
                ))}
                </tbody>
            </table>
        </div>
    );
};

export default ReportExpensesListOne;
